var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useMediaQuery, useTheme } from "@mui/material";
/**
 * Accordion Summary Content wrapper.
 * Uses CSS Grid.
 * Desktop default display: 4 columns.
 * Mobile default display: 2 columns.
 * See component for more details.
 * @param props.children
 * @param props.styles
 *
 * @returns
 */
export const Accordion_SummaryContent = (_a) => {
    var { children, sx } = _a, rest = __rest(_a, ["children", "sx"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsx(Box, Object.assign({ sx: Object.assign({ display: "grid", width: 1, gridTemplateColumns: !isMobile ? "25% 25% 25% 25%" : "50% 50%", gridTemplateAreas: !isMobile ? `"first second third fourth"` : `"first fourth"`, pl: 2, pr: 3 }, sx) }, rest, { children: children })));
};
